/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerModel } from '../../models/practitioner-model';

export interface PractitionerIdGet$Params {
  id: string;
}

export function practitionerIdGet(http: HttpClient, rootUrl: string, params: PractitionerIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PractitionerModel>> {
  const rb = new RequestBuilder(rootUrl, practitionerIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PractitionerModel>;
    })
  );
}

practitionerIdGet.PATH = '/Practitioner/{id}';
